import { Space } from "antd";
import { TagsCell } from "common/components/tagsCell/tagsCell";
import { isPermissionPresent } from "utilities/generalUtility";
import { displayDollar, formatBool } from "utilities/tableUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import K from "utilities/constants";
import { EditJobButton } from "./editJobButton/editJobButton";
import { DeleteJobButton } from "./deleteJobButton/deleteJobButton";

const actionColumnRenderer =
  (clientId, roles, onJobUpdated, onJobDeleted) => (params) => (
    <Space>
      {isPermissionPresent(K.Permissions.EditJob, roles) && (
        <EditJobButton
          clientId={clientId}
          job={params.data}
          onSuccess={onJobUpdated}
        />
      )}

      {isPermissionPresent(K.Permissions.DeleteJob, roles) && (
        <DeleteJobButton
          clientId={clientId}
          job={params.data}
          onSuccess={() => onJobDeleted(params.data)}
        />
      )}
    </Space>
  );

export const getColumns = (clientId, roles, onJobUpdated, onJobDeleted) => [
  {
    ...DefaultColumnOptions.Id,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
  },
  {
    headerName: "Job Recruiter(s)",
    field: "jobRecruiters",
    sortable: false,
    valueGetter: ({ data }) =>
      data.jobRecruiters.map((r) => r.recruiter.name).join(", "),
    cellRenderer: ({ data }) => (
      <TagsCell
        items={data.jobRecruiters.map((r) => r.recruiter)}
        color="#0070C0"
      />
    ),
    tooltipValueGetter: (params) => params.value,
  },
  {
    headerName: "Title",
    field: "title",
    tooltipField: "title",
  },
  {
    headerName: "Current Openings",
    field: "currentOpenings",
    headerTooltip: "Current Openings",
    tooltipField: "currentOpenings",
  },
  {
    headerName: "Job Location",
    field: "jobLocation.name",
    headerTooltip: "Job Location",
    sortable: true,
    tooltipField: "jobLocation.name",
  },
  {
    headerName: "Job Department",
    field: "jobDepartment.name",
    headerTooltip: "Job Department",
    sortable: true,
    tooltipField: "jobDepartment.name",
  },
  {
    headerName: "Job Group",
    field: "jobGroup.name",
    sortable: true,
    tooltipField: "jobGroup.name",
  },
  {
    headerName: "Job Hiring Manager(s)",
    field: "jobHiringManagers",
    headerTooltip: "Job Hiring Manager(s)",
    sortable: false,
    valueGetter: ({ data }) =>
      data.jobHiringManagers.map((m) => m.hiringManager.name).join(", "),
    cellRenderer: ({ data }) => (
      <TagsCell
        items={data.jobHiringManagers.map((m) => m.hiringManager)}
        color="#BDD7EE"
      />
    ),
    tooltipValueGetter: (params) => params.value,
  },
  {
    headerName: "Recruiting Start Date",
    field: "recruitingStartDate",
    headerTooltip: "Recruiting Start Date",
    sort: "asc",
    valueGetter: ({ data }) =>
      convertIntoDashUSFormat(data.recruitingStartDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Min Pay",
    field: "minPay",
    tooltipField: "minPay",
    valueGetter: ({ data }) => displayDollar(data.minPay),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Max Pay",
    field: "maxPay",
    valueGetter: ({ data }) => displayDollar(data.maxPay),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Billing Tier",
    field: "jobTier.name",
    tooltipField: "jobTier.name",
  },
  {
    headerName: "ATS ID",
    field: "extAtsId",
    tooltipField: "extAtsId",
  },
  {
    headerName: "Job Status",
    field: "jobStatus.name",
    tooltipField: "jobStatus.name",
  },
  {
    headerName: "Cancelled?",
    field: "isCancel",
    valueGetter: ({ data }) => formatBool(data.isCancel),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide:
      !isPermissionPresent(K.Permissions.DeleteJob, roles) &&
      !isPermissionPresent(K.Permissions.EditJob, roles),
    cellRenderer: actionColumnRenderer(
      clientId,
      roles,
      onJobUpdated,
      onJobDeleted,
    ),
  },
];
